(function () {
  function getModal() {
    return document.getElementById('recipe-shopping-modal');
  }

  function setAddAllButtons(disabled) {
    var modalAddAll = document.getElementById('modal-add-all-btn');
    var inlineAddAll = document.getElementById('recipe-add-all-inline-btn');
    if (modalAddAll) modalAddAll.disabled = disabled;
    if (inlineAddAll) inlineAddAll.disabled = disabled;
  }

  if (window.recipeModalFunctions) {
    delete window.recipeModalFunctions;
  }

  window.recipeModalFunctions = {
    openModal: function () {
      var modal = getModal();
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.updateDisplay();
      }
    },

    closeModal: function () {
      var modal = getModal();
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    },

    toggleAll: function () {
      var modal = getModal();
      if (!modal) return;
      var checkboxes = modal.querySelectorAll('.product-checkbox:not([disabled])');
      var allChecked = Array.from(checkboxes).every(function (cb) {
        return cb.checked;
      });
      checkboxes.forEach(function (cb) {
        cb.checked = !allChecked;
      });
      this.updateDisplay();
    },

    updateDisplay: function () {
      var modal = getModal();
      if (!modal) return;

      var checked = modal.querySelectorAll('.product-checkbox:checked');
      var addable = modal.querySelectorAll('.product-checkbox:not([disabled])');
      var totalEl = modal.querySelector('#modal-cart-total');
      var countEl = modal.querySelector('#modal-item-count');
      var addBtn = modal.querySelector('#modal-add-btn');
      var toggleBtn = modal.querySelector('#modal-toggle-btn');

      if (totalEl && countEl) {
        var total = 0;
        checked.forEach(function (cb) {
          total += parseFloat(cb.dataset.price || '0') || 0;
        });
        totalEl.textContent = total.toFixed(2).replace('.', ',') + ' kr';
        countEl.textContent = checked.length;
      }

      if (addBtn) addBtn.disabled = checked.length === 0;

      if (toggleBtn) {
        var allChecked = addable.length > 0 && Array.from(addable).every(function (cb) {
          return cb.checked;
        });
        toggleBtn.textContent = allChecked ? 'Fjern alle' : 'Velg alle';
      }

      var hasAddable = addable.length > 0;
      setAddAllButtons(!hasAddable);
    },

    /* Collect unique in-stock variant IDs from the given NodeList/Array of checkboxes */
    _collectItems: function (checkboxes) {
      var seen = new Set();
      var items = [];
      checkboxes.forEach(function (cb) {
        var id = cb.dataset.variantId;
        if (id && !seen.has(id)) {
          seen.add(id);
          items.push({ id: parseInt(id, 10), quantity: 1 });
        }
      });
      return items;
    },

    /* Single batched POST to /cart/add.js — one request, no delays */
    _batchAdd: function (items, button, originalText) {
      var self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw new Error(body.description || 'HTTP ' + response.status);
            });
          }
          return response.json();
        })
        .then(function () {
          /* Success — restore button, clear selections, refresh UI */
          button.textContent = originalText;

          var modal = getModal();
          if (modal) {
            modal.querySelectorAll('.product-checkbox').forEach(function (cb) {
              cb.checked = false;
            });
          }

          self.updateDisplay(); /* re-enables add-all buttons, disables add-selected */
          self.updateCartDisplay();
          self.closeModal();

          self._toast(
            items.length + ' produkt' + (items.length > 1 ? 'er' : '') + ' lagt til i kurven!'
          );
        })
        .catch(function (err) {
          console.error('Recipe cart error:', err);
          button.textContent = 'Feil — prøv igjen';
          setTimeout(function () {
            button.textContent = originalText;
            self.updateDisplay(); /* re-enables all buttons based on current state */
          }, 2500);
        });
    },

    addToCart: function () {
      var modal = getModal();
      if (!modal) return;

      var items = this._collectItems(modal.querySelectorAll('.product-checkbox:checked'));
      if (items.length === 0) {
        alert('Velg minst ett produkt');
        return;
      }

      var button = modal.querySelector('#modal-add-btn');
      if (!button) return;

      var originalText = button.textContent;
      button.textContent = 'Legger til...';
      button.disabled = true;
      setAddAllButtons(true);

      this._batchAdd(items, button, originalText);
    },

    addAllToCart: function (opts) {
      var modal = getModal();
      if (!modal) return;

      var items = this._collectItems(modal.querySelectorAll('.product-checkbox:not([disabled])'));
      if (items.length === 0) {
        alert('Ingen produkter på lager å legge til.');
        return;
      }

      var button =
        (opts && opts.button) ||
        document.getElementById('modal-add-all-btn') ||
        document.getElementById('recipe-add-all-inline-btn');
      if (!button) return;

      var originalText = button.textContent;
      button.textContent = 'Legger til...';
      /* Disable all cart-action buttons while in flight */
      button.disabled = true;
      var mainBtn = document.getElementById('modal-add-btn');
      if (mainBtn) mainBtn.disabled = true;
      var otherAddAll =
        button.id === 'recipe-add-all-inline-btn'
          ? document.getElementById('modal-add-all-btn')
          : document.getElementById('recipe-add-all-inline-btn');
      if (otherAddAll) otherAddAll.disabled = true;

      this._batchAdd(items, button, originalText);
    },

    updateCartDisplay: async function () {
      try {
        var cartData;
        if (typeof window.fetchCartData === 'function') {
          cartData = await window.fetchCartData(true);
        } else {
          var cartUrl =
            typeof FoxTheme !== 'undefined' && FoxTheme.routes && FoxTheme.routes.cart_url
              ? FoxTheme.routes.cart_url
              : '/cart.js';
          var fetchOpts =
            typeof FoxTheme !== 'undefined' && FoxTheme.utils && FoxTheme.utils.fetchConfig
              ? FoxTheme.utils.fetchConfig()
              : {};
          var res = await fetch(cartUrl, fetchOpts);
          cartData = await res.json();
        }

        if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } })
        );
      } catch (e) {
        console.error('Recipe: failed to refresh cart UI', e);
      }
    },

    _toast: function (message) {
      var t = document.createElement('div');
      t.className = 'success-toast';
      t.textContent = message;
      document.body.appendChild(t);
      setTimeout(function () {
        t.style.transition = 'opacity 0.4s ease';
        t.style.opacity = '0';
        setTimeout(function () { t.remove(); }, 400);
      }, 3000);
    },
  };

  /* Global onclick handlers */
  window.openRecipeModal = function () { window.recipeModalFunctions.openModal(); };
  window.closeRecipeModal = function () { window.recipeModalFunctions.closeModal(); };
  window.modalToggleAll = function () { window.recipeModalFunctions.toggleAll(); };
  window.modalAddSelectedToCart = function () { window.recipeModalFunctions.addToCart(); };
  window.modalAddAllToCart = function () {
    window.recipeModalFunctions.addAllToCart({ button: document.getElementById('modal-add-all-btn') });
  };
  window.recipeAddAllInlineToCart = function () {
    window.recipeModalFunctions.addAllToCart({ button: document.getElementById('recipe-add-all-inline-btn') });
  };

  function initializeModal() {
    var modal = getModal();
    if (!modal) return;

    /* Event delegation — one listener for all checkboxes */
    modal.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('product-checkbox')) {
        window.recipeModalFunctions.updateDisplay();
      }
    });

    window.recipeModalFunctions.updateDisplay();

    /* Close on backdrop click */
    document.addEventListener('click', function (e) {
      if (e.target === document.getElementById('recipe-shopping-modal')) {
        window.recipeModalFunctions.closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeModal);
  } else {
    setTimeout(initializeModal, 0);
  }
})();
